<template>
  <div style="margin-left: 30px">
    <el-select
      v-model="selectedCredentialId"
      placeholder="请选择Google凭证"
      @focus="loadCredentialList"
      @change="selectCredential"
      class="cred-select"
      size="small"
    >
      <el-option
        v-for="item in credentialList"
        :key="item.credentialUserId"
        :label="item.aliasName || item.displayName"
        :value="item.credentialUserId"
      >
        <div>
          <div class="font-medium">{{ item.aliasName || item.displayName }}</div>
          <div class="text-xs text-gray-500">ID: {{ item.credentialUserId }}</div>
        </div>
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { credentialList } from '@/api/google/account';

export default {
  name: 'GoogleCred',
  data: () => ({
    credentialList: [],
    selectedCredentialId: null,
  }),
  methods: {
    async loadCredentialList() {
      if (this.credentialList.length) return;

      try {
        const { code, data } = await credentialList({ page_size: 1000, page_number: 1 });
        if (code === 0)
          this.credentialList = [
            {
              aliasName: '全部凭证',
              credentialUserId: 0,
            },
          ].concat(data?.list || []);
      } catch (error) {
        console.error('获取凭证列表失败:', error);
      }
    },
    async selectCredential(credentialUserId) {
      this.$router.push({
        ...this.$route,
        query: { ...this.$route.query, credentialUserId },
      });

      localStorage.setItem('googleCredentialUserId', credentialUserId);

      const credential = this.credentialList.find((item) => item.credentialUserId === credentialUserId);
      this.$emit('credential-selected', credential);
      this.$emit('credential-changed', {
        credentialUserId,
        accountId: this.$route.query.account_id,
      });
    },
  },
  async created() {
    await this.loadCredentialList();
    let credentialId =
      Number(this.$route.query.credentialUserId) || Number(localStorage.getItem('googleCredentialUserId'));
    this.selectedCredentialId = credentialId || 0;

    this.selectCredential(this.selectedCredentialId);
  },
  watch: {
    '$route.query.credentialUserId'(val) {
      this.selectedCredentialId = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.cred-select {
  width: 200px;
}

// ::v-deep .el-select .el-input__inner {
//   background-color: #fff;
//   border-color: #16a085;
//   color: white;
// }

// ::v-deep .el-select .el-input__suffix {
//   color: white;
// }
</style>
